import { loadablePage } from '../../utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "pages.registration" */ /* webpackPrefetch: true */
      './ThankYouPage.component'
    ),
);
